<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Task Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading title="New Prep Task">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add prep task'">
      <template #gated-content>
        <prep-task-form :prep_process="prep_process" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import PrepTaskForm from "@/components/lab/preptask/PrepTaskForm";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { prepTaskNotifications } from "@/shared/notifications";

const PrepTaskRepository = LabRepositoryFactory.get("prepTask");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "PrepTaskAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    PrepTaskForm,
  },
  data() {
    return {
      loading: true,
      prep_process_id: this.$route.params.prep_process_id || null,
      prep_process: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: `/prep-processes/${this.prep_process_id}`,
            title: "Prep Task list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      const { name, description, relations } = form_data;
      const payload = {
        name,
        description,
        relations,
        prep_process_id: this.prep_process_id,
      };

      try {
        const { data } = await PrepTaskRepository.create(payload);

        this.addSuccess();

        this.$router.push(`/prep-tasks/${data.id}`);
      } catch ({ response }) {
        this.$bvToast.toast(response.data.error, {
          title: "Task creation Failed.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.prep_process = await getModel({
      model_type: "prep_process",
      id: this.prep_process_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: prepTaskNotifications,
};
</script>
